import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    fieldsChasis: {
        inputEstPuntaDelDer: null,
        inputEstPuntaDelIzq: null,
        inputEstFrontalSup: null,
        inputEstFrontalInt: null,
        inputEstCunaMotor: null,
        inputEstParales: null,
        inputEstPisoBaul: null,
        inputEstRefPiso: null,
        inputEstPuntasTra: null
    },
    fieldsFugas: {
        inputEstFugaAceMotor: null,
        inputEstFugaAceCajaVel: null,
        inputEstFugaAceCajaTran: null,
        inputEstFugaSistFrenos: null,
        inputEstFugaSisRefig: null,
        inputEstFugaSistAire: null,
        inputEstFugaAceDirHid: null,
        inputEstFugaLiqBomba: null,
        inputEstFugaTanqueComb: null,
    },
    fieldsMotor: {
        inputEstFunAA: null,
        inputEstMangueraRad: null,
        inputEstCorreas: null,
        inputEstTenCorreas: null,
        inputEstFiltroAceite: null,
        inputEstExtBat: null,
        inputEstCargaBat: null,
        inputEstRadiador: null,
        inputEstRadiadorAA: null,
        inputEstSopMotor: null,
        inputEstCarcasCaja: null,
        inputEstAmortCapot: null,
        inputEstViscAceite: null,
    },
    fieldsBaja: {
        inputEstTanqueSil: null,
        inputEstTubExos: null,
        inputEstTanqueCataGas: null,
        inputEstCauchosSusp: null,
        inputEstTijeras: null,
        inputEstGuardaEjes: null,
        inputEstCarter: null,
        inputEstProtecInf: null,
        inputEstGuardaCajaDir: null,
        inputEstTubFreno: null,
        inputEstBujesBarraEst: null,
        inputEstBujesTije: null,
        inputEstGuardaBrazoAx: null,
        inputEstGuardaSem: null,
    },
    fieldsLuces: {
        inputEstLucesAlt: null,
        inputEstLucesBaj: null,
        inputEstLucesAnt: null,
        inputEstCocuyos: null,
        inputEstDireccionales: null,
        inputEstacionamiento: null,
        inputEstExploradoras: null,
        inputEstLuzFreno: null,
        inputEstLuzPlaca: null,
        inputEstLuzRev: null,
        inputEstLuzTec: null,
    },
    fieldsInterior: {
        inputEstFunLimpDel: null,
        inputEstFunLimpTra: null,
        inputEstFunAireAcond: null,
        inputEstFunCalef: null,
        inputEstFunRadio: null,
        inputEstFunEspElect: null,
        inputEstFunReloj: null,
        inputEstFunPito: null,
        inputEstAsiDel: null,
        inputEstArranqEnc: null,
        inputEstFunSunroof: null,
        inputEstTestigoAbs: null,
        inputEstTestifoAirBag: null,
        inputEstCheckEng: null,
        inputEstElevaVidrio: null,
    },
    fieldsTapiceria: {
        inputEstAlfombraPiso: null,
        inputEstConsolaCent: null,
        inputEstCarterasPuer: null,
        inputEstCinturonSeg: null,
        inputEstGuantera: null,
        inputEstMillare: null,
        inputEstParasoles: null,
        inputEstTapAsient: null,
        inputEstTapTecho: null,
        inputEstVolante: null,
        inputEstPalancaCam: null,
        inputEstFrenMano: null,
    },
    identificacion:{
        nrochasis:null,
        estadochasis: null,
        nromotor:null,
        estadomotor: null,
        nroserie:null,
        estadoserie: null
    },
    llantas: {
        delDerechaSelector: null,
        delDerechaInput: null,
        delIzquierdaSelector: null,
        delIzquierdaInput: null,
        traDerechaSelector: null,
        traDerechaInput: null,
        traIzquierdaSelector: null,
        traIzquierdaInput: null,
        amorDelanteroSelector: null,
        amorDelanteroInput: null,
        amorTraseroSelector: null,
        amorTraseroInput: null
    }

};
const mutations = {
    updateField,
    updateGeneral: (state, payload) => {
        if (payload.length !== 0) {
            state.fieldsChasis = payload.fieldsChasis;
            state.fieldsFugas = payload.fieldsFugas;
            state.fieldsMotor = payload.fieldsMotor;
            state.fieldsBaja = payload.fieldsBaja;
            state.fieldsLuces = payload.fieldsLuces;
            state.fieldsInterior = payload.fieldsInterior;
            state.fieldsTapiceria = payload.fieldsTapiceria;
            state.identificacion = payload.identificacion;
            state.llantas = payload.llantas;
        }
    },
    updatedatos: (state, payload) => {
        state.identificacion.nrochasis =  payload.numero_chasis;
        state.identificacion.nromotor =  payload.numero_motor;
        state.identificacion.nroserie =  payload.numero_serie;
    }

};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
